











































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import { storeCeklistProsedurInvasif } from "@/store/modules/CeklistProsedurInvasifStore";
import CeklistProsedurInvasifSvc from "@/services/CeklistProsedurInvasif";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component({
  components: {
    CardModalTtd,
    DokterAutoComplete
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardCeklistProsedurInvasif extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: false }) isActive!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("ceklis_prosedur_invasif", "create");
  }

  isFormOpen = false;
  isCreating = false;
  isEditing = false;
  editingId: number | null = null;
  modalTtd = false;
  signRole = "";
  signItem: any = null;
  saving = false;
  menuTgl = false;
  menuJam = false;
  stepperStep = 1;

  tglPicker = "";
  jamPicker = "08:00";

  form: any = this.getEmptyForm();

  // Checklist item definitions
  signInItems = [
    { field: "si_benar_pasien", label: "Benar Pasien — identifikasi pasien diperiksa, gelang tangan / label dicocokkan" },
    { field: "si_informed_consent", label: "Formulir persetujuan tindakan (Informed Consent) ada dan sudah ditandatangani" },
    { field: "si_benar_peralatan", label: "Benar peralatan / implan tersedia dan siap" },
    { field: "si_benar_imaging", label: "Hasil imaging / pemeriksaan penunjang terkait tersedia" }
  ];

  timeOutCheckItems = [
    { field: "to_benar_pasien", label: "Benar Pasien — verifikasi ulang identitas pasien dengan gelang identitas" },
    { field: "to_benar_prosedur", label: "Benar Prosedur — prosedur yang akan dilakukan dikonfirmasi tim" },
    { field: "to_benar_lokasi", label: "Benar Lokasi/Sisi — lokasi/sisi tubuh pasien sudah diperiksa dan dikonfirmasi benar" }
  ];

  signOutItems = [
    { field: "so_nama_prosedur_dicatat", label: "Nama prosedur telah dicatat" },
    { field: "so_instrumen_dihitung", label: "Perhitungan instrumen, kassa dan jarum lengkap" },
    { field: "so_spesimen_label", label: "Spesimen telah diberi label identitas dan asal jaringan" },
    { field: "so_masalah_peralatan", label: "Keluhan dan permasalahan peralatan sudah ditangani" }
  ];

  mounted() {
    storeCeklistProsedurInvasif.getByRegister(this.register);
  }

  getEmptyForm() {
    return {
      tgl_prosedur: "",
      // Sign In
      si_benar_pasien: null,
      si_informed_consent: null,
      si_benar_peralatan: null,
      si_benar_imaging: null,
      si_completed_at: null,
      // Time Out
      to_benar_pasien: null,
      to_benar_prosedur: null,
      to_nama_prosedur: "",
      to_benar_lokasi: null,
      to_lokasi_sisi: "",
      to_completed_at: null,
      // Sign Out
      so_nama_prosedur_dicatat: null,
      so_instrumen_dihitung: null,
      so_spesimen_label: null,
      so_masalah_peralatan: null,
      so_completed_at: null,
      // Dokter
      dpjp_id: null,
      dpjp_obj: null,
      pelaksana_id: null,
      pelaksana_obj: null
    };
  }

  // ==================== COMPUTED ====================

  get stateList() {
    return storeCeklistProsedurInvasif.list;
  }

  get stateLoading() {
    return storeCeklistProsedurInvasif.loading;
  }

  get stateuser() {
    return userModule.user;
  }

  get isSignInComplete(): boolean {
    return !!this.form.si_benar_pasien
      && !!this.form.si_informed_consent
      && !!this.form.si_benar_peralatan
      && !!this.form.si_benar_imaging;
  }

  get isTimeOutComplete(): boolean {
    return !!this.form.to_benar_pasien
      && !!this.form.to_benar_prosedur
      && !!this.form.to_nama_prosedur
      && !!this.form.to_benar_lokasi
      && !!this.form.to_lokasi_sisi;
  }

  get isSignOutComplete(): boolean {
    return !!this.form.so_nama_prosedur_dicatat
      && !!this.form.so_instrumen_dihitung
      && !!this.form.so_spesimen_label
      && !!this.form.so_masalah_peralatan
      && !!this.form.dpjp_id
      && !!this.form.pelaksana_id;
  }

  get canEditSignIn(): boolean {
    if (this.readOnly) return false;
    return !this.form.to_completed_at;
  }

  get canEditTimeOut(): boolean {
    if (this.readOnly) return false;
    return !!this.form.si_completed_at && !this.form.so_completed_at;
  }

  get canEditSignOut(): boolean {
    if (this.readOnly) return false;
    return !!this.form.to_completed_at;
  }

  // ==================== HELPERS ====================

  formatTgl(date) {
    return getHumanDateTime(date);
  }

  isFullySigned(item) {
    return item.signed_dpjp && item.signed_pelaksana;
  }

  canEdit(item) {
    return !item.signed_dpjp && !item.signed_pelaksana;
  }

  canDelete(item) {
    if (this.readOnly) return false;
    return !alasanTtdMengunciHapus(
      item.creator_user_id,
      [
        { ditandatangani: item.signed_dpjp, penandaTanganId: item.dpjp_id },
        { ditandatangani: item.signed_pelaksana, penandaTanganId: item.pelaksana_id }
      ],
      this.stateuser && this.stateuser.id
    );
  }

  canSignDpjp(item) {
    return item.so_completed_at && !item.signed_dpjp && item.dpjp_id == this.stateuser.id;
  }

  canSignPelaksana(item) {
    return item.so_completed_at && !item.signed_pelaksana && item.pelaksana_id == this.stateuser.id;
  }

  triColor(val: string) {
    if (val === "ya") return "green";
    if (val === "tidak") return "red";
    if (val === "tdd") return "grey";
    return "grey lighten-2";
  }

  triLabel(val: string) {
    if (val === "ya") return "Ya";
    if (val === "tidak") return "Tidak";
    if (val === "tdd") return "TDD";
    return "-";
  }

  setDpjp(dokter) {
    if (dokter) {
      this.form.dpjp_id = dokter.id;
      this.form.dpjp_obj = dokter;
    }
  }

  setPelaksana(dokter) {
    if (dokter) {
      this.form.pelaksana_id = dokter.id;
      this.form.pelaksana_obj = dokter;
    }
  }

  // ==================== ACTIONS ====================

  startCreate() {
    this.form = this.getEmptyForm();
    const now = new Date();
    this.tglPicker = localISODate(now);
    this.jamPicker = now.toTimeString().substring(0, 5);
    this.form.tgl_prosedur = `${this.tglPicker} ${this.jamPicker}`;
    this.stepperStep = 1;
    this.isCreating = true;
    this.isEditing = false;
    this.editingId = null;
    this.isFormOpen = true;
  }

  startEdit(item) {
    this.form = {
      ...item,
      dpjp_obj: item.dpjp_nama ? { id: item.dpjp_id, nama: item.dpjp_nama } : null,
      pelaksana_obj: item.pelaksana_nama ? { id: item.pelaksana_id, nama: item.pelaksana_nama } : null
    };
    if (item.tgl_prosedur) {
      const dt = item.tgl_prosedur.substring(0, 10);
      const tm = item.tgl_prosedur.substring(11, 16);
      this.tglPicker = dt;
      this.jamPicker = tm || "08:00";
    }
    // Determine which step to show
    if (!item.si_completed_at) {
      this.stepperStep = 1;
    } else if (!item.to_completed_at) {
      this.stepperStep = 2;
    } else if (!item.so_completed_at) {
      this.stepperStep = 3;
    } else {
      this.stepperStep = 3;
    }
    this.isEditing = true;
    this.isCreating = false;
    this.editingId = item.id;
    this.isFormOpen = true;
  }

  cancelForm() {
    this.isFormOpen = false;
    this.isCreating = false;
    this.isEditing = false;
    this.editingId = null;
    this.form = this.getEmptyForm();
  }

  async simpanFase(fase: string) {
    this.saving = true;
    this.form.tgl_prosedur = `${this.tglPicker} ${this.jamPicker}`;

    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const payload: any = {
        register_id: this.register,
        pasien_rm: this.rm,
        tgl_prosedur: this.form.tgl_prosedur
      };

      if (fase === "signIn") {
        payload.si_benar_pasien = this.form.si_benar_pasien;
        payload.si_informed_consent = this.form.si_informed_consent;
        payload.si_benar_peralatan = this.form.si_benar_peralatan;
        payload.si_benar_imaging = this.form.si_benar_imaging;
      } else if (fase === "timeOut") {
        payload.to_benar_pasien = this.form.to_benar_pasien;
        payload.to_benar_prosedur = this.form.to_benar_prosedur;
        payload.to_nama_prosedur = this.form.to_nama_prosedur;
        payload.to_benar_lokasi = this.form.to_benar_lokasi;
        payload.to_lokasi_sisi = this.form.to_lokasi_sisi;
      } else if (fase === "signOut") {
        payload.so_nama_prosedur_dicatat = this.form.so_nama_prosedur_dicatat;
        payload.so_instrumen_dihitung = this.form.so_instrumen_dihitung;
        payload.so_spesimen_label = this.form.so_spesimen_label;
        payload.so_masalah_peralatan = this.form.so_masalah_peralatan;
        payload.dpjp_id = this.form.dpjp_obj ? this.form.dpjp_obj.id : this.form.dpjp_id;
        payload.pelaksana_id = this.form.pelaksana_obj ? this.form.pelaksana_obj.id : this.form.pelaksana_id;
      }

      let resp;
      if (this.isCreating && !this.editingId) {
        // Create baru (fase signIn pertama kali)
        resp = await CeklistProsedurInvasifSvc.create(payload);
        if (resp.data.status == "1") {
          this.editingId = resp.data.data.id;
          this.isCreating = false;
          this.isEditing = true;
        }
      } else {
        resp = await CeklistProsedurInvasifSvc.update(this.editingId, payload);
      }

      if (resp.data.status == "1") {
        const labels = { signIn: "Sign In", timeOut: "Time Out", signOut: "Sign Out" };
        appModule.NoticeDelay(`${labels[fase]} berhasil disimpan`);

        // Update form state from response
        const newData = resp.data.data;
        this.form = {
          ...this.form,
          ...newData,
          dpjp_obj: this.form.dpjp_obj,
          pelaksana_obj: this.form.pelaksana_obj
        };

        // Move to next step
        if (fase === "signIn") {
          this.stepperStep = 2;
        } else if (fase === "timeOut") {
          this.stepperStep = 3;
        } else if (fase === "signOut") {
          // All phases complete, close form and refresh
          this.cancelForm();
          storeCeklistProsedurInvasif.getByRegister(this.register);
          return;
        }

        // Refresh list
        storeCeklistProsedurInvasif.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  async remove(item) {
    if (!confirm("Anda yakin akan menghapus ceklist prosedur invasif ini?")) return;
    const resp = await CeklistProsedurInvasifSvc.destroy(item.id);
    if (resp?.status == 1) {
      appModule.NoticeDelay(resp.message);
      storeCeklistProsedurInvasif.getByRegister(this.register);
    }
  }

  cetakPdf(item) {
    CeklistProsedurInvasifSvc.print(item.id);
  }

  openTtd(item, role: string) {
    this.signItem = item;
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const signFn = this.signRole === "dpjp"
      ? CeklistProsedurInvasifSvc.signDpjp
      : CeklistProsedurInvasifSvc.signPelaksana;

    const resp = await signFn(this.signItem.id, { password });

    if (resp.data.status == "1") {
      this.modalTtd = false;
      const label = this.signRole === "dpjp" ? "DPJP" : "Pelaksana";
      appModule.NoticeDelay(`Berhasil Tanda Tangan ${label}`);
      appModule.addMsgTtd("");
      storeCeklistProsedurInvasif.getByRegister(this.register);
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  @Watch("tglPicker")
  onTglChange() {
    this.form.tgl_prosedur = `${this.tglPicker} ${this.jamPicker}`;
  }

  @Watch("jamPicker")
  onJamChange() {
    this.form.tgl_prosedur = `${this.tglPicker} ${this.jamPicker}`;
  }

  @Watch("register")
  onRegisterChange() {
    storeCeklistProsedurInvasif.getByRegister(this.register);
  }
}
